__turbopack_context__.v({
  "content": "WhatsNewContent-module-scss-module__UdH0Mq__content",
  "cta": "WhatsNewContent-module-scss-module__UdH0Mq__cta",
  "still-alternative": "WhatsNewContent-module-scss-module__UdH0Mq__still-alternative",
  "wrapper": "WhatsNewContent-module-scss-module__UdH0Mq__wrapper",
});
